import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { PersonAPI } from "@ai360/core";
import { injectIntl, intlShape } from "@ai360/core/intl";
import { messages } from "../i18n-messages";
import { SelectInput, withAsyncOptions } from "~/core";
import { getTheUserGuid } from "~/login/selectors";
import { actions as notificationActions } from "~/notifications";
import { SearchIcon } from "~/core/icons";
import classnames from "classnames";

// Styles
import "./component.css";

const searchIcon = (
    <span key="search" className="search-icon">
        <SearchIcon className="search-icon" />
    </span>
);

class SearchSupervisor extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        fetchData: PropTypes.func,
        onSelection: PropTypes.func,
        initialValue: PropTypes.string,
        className: PropTypes.string,
        userGuid: PropTypes.string,
        autoFocus: PropTypes.bool,
        onApiCallErr: PropTypes.func,
    };

    static defaultProps = {
        filteredData: [],
        autoFocus: false,
        className: "",
    };

    static PERSON_NAME = "personName";
    static PERSON_JOB = "jobTitleName";
    static PERSON_CITY = "city";
    static PERSON_GUID = "personGuid";
    static PERSON_STATE_ABR = "stateAbbreviation";
    static DROPDOWN_NAME = "supervisorList";
    static SEARCH_URL = PersonAPI.SEARCH_PERSON_WITH_USER;

    constructor(props) {
        super(props);
        this.state = {
            initialValue: "",
        };
        this.AsyncSelectInput = withAsyncOptions(SelectInput, (userFilterStr) =>
            this.getUserOptions(userFilterStr)
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.initialValue !== this.props.initialValue) {
            this.setState({
                initialValue: nextProps.initialValue,
            });
        }
    }

    onItemSelection = (guid) => {
        if (this.props.onSelection) {
            this.props.onSelection(guid);
        }
    };

    onInputChange = (initialValue) => this.setState({ initialValue });

    getUserOptions = (filterStr) => {
        if (filterStr === "") {
            return Promise.resolve([]);
        }

        const { userGuid, onApiCallErr } = this.props;

        return PersonAPI.searchPersonWithUser(userGuid, filterStr)
            .then((results) =>
                results.map((record) => ({
                    ...record,
                    label: record[SearchSupervisor.PERSON_NAME],
                }))
            )
            .catch((err) => {
                onApiCallErr(err);
                return [];
            });
    };

    optionRenderer = ({ option, isSelected, isHighlighted }) => {
        const className = classnames(
            "select-form-input-option",
            {
                selected: isSelected,
                "filter-match": isHighlighted,
            },
            "search-person-options"
        );
        const cityAndState = [
            option[SearchSupervisor.PERSON_CITY],
            option[SearchSupervisor.PERSON_STATE_ABR],
        ].join(", ");
        const optionTitle = [
            option[SearchSupervisor.PERSON_NAME],
            option[SearchSupervisor.PERSON_JOB],
            cityAndState,
        ].join(" ");
        return (
            <div className={className} title={optionTitle}>
                <div className="person-info">
                    <div className="person-name">{option[SearchSupervisor.PERSON_NAME]}</div>
                    <div className="person-jobtitle">{option[SearchSupervisor.PERSON_JOB]}</div>
                </div>
                <div className="person-state">{cityAndState} </div>
            </div>
        );
    };

    render() {
        const { formatMessage } = this.props.intl;
        const { AsyncSelectInput } = this;
        return (
            <AsyncSelectInput
                allowEmptyOptions
                arrowRenderer={() => null}
                clearFilterInputOnBlur={false}
                containerClassNames={["person-filter", this.props.className]}
                initialFilterStr={this.state.initialValue}
                inputContainerLeftElements={[searchIcon]}
                minOptionsWidth={350}
                onChange={(val) => this.onItemSelection(val)}
                onInputChange={(val) => this.onInputChange(val)}
                optionHeight={42}
                optionRenderer={this.optionRenderer}
                placeholderText={formatMessage(messages.searchFor, {
                    searchedFor: formatMessage(messages.supervisor),
                })}
                value={this.state.initialValue}
                valueKey={SearchSupervisor.PERSON_GUID}
            />
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    onApiCallErr: (error) => dispatch(notificationActions.apiCallError(error)),
});

const mapStateToProps = (state) => ({
    userGuid: getTheUserGuid(state),
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SearchSupervisor));
